/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toMessageProps } from './translator/message'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchMessage, GetMessage } from '@/infrastructure/network/Monitaro/requests/message'

export default class Message extends MonitaroGatewayBase {
  async FetchMessage(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchMessage(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.messages.map((prop) => toMessageProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetMessage(id: string) {
    const { message } = await this.apiClient.request(new GetMessage(id))
    return toMessageProps(message)
  }
}
